<emperor-masked-input
  class="npn-input"
  [formControl]="formControl"
  [label]="label"
  [mask]="npnMask"
  [errorMessageMap]="npnErrorMessageMap"
  [isReadOnly]="isReadOnly"
  [isOptional]="isOptional"
  [hint]="!isReadOnly ? hintText : ''"
></emperor-masked-input>
